<template>
  <div>
    <div v-if="show">
      <formulas-by-resource-dialog
        v-model="formulas"
        :resourceName="value?.label ?? 'N/A'"
        :subTitle="$t('formula.byResource.includedTagKey')"
        @cancel="cancel"
        @forceRemove="forceRemove"
      />
      <delete-dialog
        :dialog="deleteConfirmDialog"
        v-on:confirm-delete="remove"
        v-on:cancel-dialog="cancel"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import DeleteDialog from "@/components/common/DeleteDialog";
import FormulasByResourceDialog from "@/components/formula/FormulasByResourceDialog";

export default {
  name: "DeleteTagKeyDialog",

  components: {
    DeleteDialog,
    FormulasByResourceDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Object,
      default: () => ({}),
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      deleteConfirmDialog: false,
      formulas: [],
    };
  },

  methods: {
    ...mapActions("formulas", ["getFormulasByTagKey"]),
    ...mapActions("tag", ["deleteTagKey", "deleteTagKeyForce"]),

    ...mapActions("alert", ["success", "error"]),

    async remove() {
      if (
        this.value?.tagDeveui == null ||
        this.value?.tagDeveui == undefined ||
        this.value?.key == null ||
        this.value?.key == undefined
      ) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      (await this.deleteTagKey({
        tagId: this.value.tagDeveui,
        key: this.value.key,
      }))
        ? this.success(this.$t("common.deleted"))
        : this.error(this.$t("formula.errors.delete"));

      this.$emit("update");
    },

    async forceRemove() {
      if (
        this.value?.tagDeveui == null ||
        this.value?.tagDeveui == undefined ||
        this.value?.key == null ||
        this.value?.key == undefined
      ) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      (await this.deleteTagKeyForce({
        deveui: this.value.tagDeveui,
        key: this.value.key,
      }))
        ? this.success(this.$t("common.deleted"))
        : this.error(this.$t("formula.errors.delete"));

      this.$emit("update");
    },

    cancel() {
      this.$emit("cancel");
    },
  },

  async created() {
    if (this.value?.tagDeveui && this.value?.key) {
      this.formulas = await this.getFormulasByTagKey({
        deveui: this.value.tagDeveui,
        key: this.value.key,
      });
      if (this.formulas == undefined)
        this.error(this.$t("formula.errors.gettingData"));
    }
  },

  watch: {
    show: {
      //Determines if the tagkey is a formula resource to show the relevant delete dialog
      async handler(val) {
        if (val) {
          this.formulas = await this.getFormulasByTagKey({
            deveui: this.value?.tagDeveui,
            key: this.value?.key,
          });
          if (this.formulas == undefined)
            this.error(this.$t("formula.errors.gettingData"));

          this.deleteConfirmDialog = this.formulas && this.formulas.length == 0;
        }
      },
    },
  },
};
</script>
